import CustomModal from '../../../common/components/modal/CustomModal';
import DisplayRibInterface from './DisplayRibInterface';
import {useIntl} from 'react-intl';
import {Rib} from '../../../interfaces/rib';
import ButtonSubmit from '../../../modules/form/ButtonSubmit';

interface ViewRibModalProps {
    show: boolean;
    hide: () => void;
    rib: Rib;
    handleSubmit: () => void;
    isFetchingDocuSignUrl: boolean;
}

const ViewRibModal = ({
    show,
    hide,
    rib,
    handleSubmit,
    isFetchingDocuSignUrl,
}: ViewRibModalProps): JSX.Element => {
    const intl = useIntl();

    return (
        <CustomModal
            title={intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.TITLE'})}
            show={show}
            onHide={hide}
            body={<DisplayRibInterface rib={rib} />}
            footer={
                <>
                    <ButtonSubmit
                        type={'button'}
                        disabled={isFetchingDocuSignUrl}
                        isLoading={isFetchingDocuSignUrl}
                        textId={'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK.UPDATEE'}
                        onClick={handleSubmit}
                    />
                </>
            }
            size={'lg'}
        />
    );
};

export default ViewRibModal;
